import React, { useRef } from 'react';
import HomePage from '../components/Home/main';
import Brands from '../components/Home/Brands';
import Aboutus from '../components/Home/Aboutus';
import VisionMission from '../components/Home/VisionMission';
import ValueSystem from '../components/Home/ValueSystem';
import Milestones from '../components/Home/Milestones';

const Home = () => {
  const solutionsRef = useRef(null); // Create a reference for Solutions section

  return (
    <div className="App">
      <HomePage scrollToSolutions={() => solutionsRef.current?.scrollIntoView({ behavior: 'smooth' })} />
      <div ref={solutionsRef}>
        <Aboutus/>

        <VisionMission />
        <ValueSystem />
        <Milestones/>
      </div>
      <Brands />
    </div>
  );
};

export default Home;
